
import React from "react";
import "../../Styles/certified/ashley.css";

export default function Novac() {
  return (
    <>
      <div className="ashley-details-section">
        <div className="ashley-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="ashley-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="ashley-details-left">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="ashley-badge"
            />
            <div className="ashley-company-names">
              <a href="https://ashleyfurnitureindia.com/gcc" target="_blank" rel="noopener noreferrer"><img src="/assets/ashley/ass.png" alt="Novac.png" className="ashley-company-logo" /></a>
              <h1 className="ashley-full-name">
                 Ashley Furniture India Private Limited
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="ashley-details-right">
            <img
              src="/assets/ashley/ashley_1.png"
              alt="Novac Office"
              className="ashley-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="ashley-description">
          <h2>
            Why  Ashley Furniture India Private Limited is a Outstanding Workplaces
          </h2>
          <p>
           Ashley Global Capability Center has redefined what it means to build a global innovation hub in India. Launched in Chennai in 2022 with a single employee, Ashley GCC has rapidly evolved into a technology powerhouse of 500+ professionals, demonstrating a remarkable journey of strategic growth, digital transformation, people-first culture and global business impact.
          </p>
          <p>As part of Ashley Furniture Industries, the world’s largest furniture manufacturer, Ashley GCC was established to drive global innovation and support enterprise transformation across technology, operations and business functions. Operating under the “One Ashley” philosophy, the GCC ensures strong cross-functional collaboration with US leadership while staying closely aligned with global business priorities.</p>
          <p>The hiring impact has been equally strong. Ashley GCC onboarded 73 entry-level graduates and early-career professionals, strengthening its future talent pipeline, along with 15 mid and senior-level professionals who brought strategic expertise to critical roles. The organisation achieved 123.39% headcount growth by adding 215 employees, improved candidate-to-joiner conversion from 63% to 78%, reduced time-to-hire by 33% from 90 to 60 days, and generated cost savings of USD 153,911 through direct hiring and referral programs covering 113 hires. With 61% of hires sourced internally, Ashley GCC reduced dependency on external agencies while building a sustainable talent engine.</p>
          <p>Employee learning and development remain central to the GCC’s growth strategy. Through Udemy-powered learning, technical certifications and structured career advancement programs, employees are empowered to build future-ready skills. These initiatives have contributed to a strong training NPS of 75, reflecting high employee satisfaction with learning interventions.</p>
          <p>Ashley GCC has also built a high-trust and inclusive culture through employee engagement surveys, action planning at all levels, leadership forums, employee voice platforms, wellness initiatives and POSH programs focused on safety and well-being. Its culture transformation is anchored in transparency, inclusion, collaboration and leadership accessibility.</p>
          <p>Beyond business outcomes, Ashley GCC is creating meaningful community impact through STEM AI Labs and education programs for students from Grades 6–10, while collaborating with government skilling bodies to strengthen future talent readiness.</p>
          <p>The organisation is also embracing AI adoption and change leadership through initiatives such as the AI Townhall with IIT Madras, accelerating digital maturity and innovation across operations. With skills-first hiring, inclusive practices and a commitment to diverse representation, Ashley GCC continues to build a workplace where every employee belongs, grows and contributes to global impact.</p>
          <p>From a one-employee launch in 2022 to a 500+ member innovation powerhouse, Ashley GCC stands as a compelling example of how global vision, local execution, strategic talent practices and people-centric leadership can create a future-ready Global Capability Center in India.</p>
        </div>
        {/* Info Cards Section */}
        <div className="ashley-info-cards">
          <div className="ashley-info-card">
            <div className="ashley-info-title">COMPANY SIZE</div>
            <div className="ashley-info-value">560  Employees</div>
          </div>
          <div className="ashley-info-card">
            <div className="ashley-info-title">INDUSTRY</div>
            <div className="ashley-info-value"> Information Technology & Design Services </div>
          </div>
          <div className="ashley-info-card">
            <div className="ashley-info-title">CONNECT</div>
            <div className="ashley-info-icons">
              <span className="ashley-icon-round">
                <a href="https://ashleyfurnitureindia.com/gcc" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="ashley-icon-round">
                <a href="https://www.linkedin.com/company/ashleyglobalcapabilitycenter/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="ashley-icon-round">
                <a href="https://www.facebook.com/AshleyFurnitureIndustries" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
           
            </div>
          </div>
          <div className="ashley-info-card">
            <div className="ashley-info-title">LOCATION (HQ)</div>
            <div className="ashley-info-value">Chennai</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="ashley-recognition-section">
          <h2 className="ashley-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="ashley-recognition-badge">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="ashley-recognition-image"
            />
          </div>
          <div className="novac-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at Novac Section */}
        <div className="ashley-life-section">
          <h2 className="ashley-life-title">
            Life at Ashley Furniture India Private Limited
          </h2>
          <div className="ashley-life-gallery">
            <div className="ashley-life-col">
              <img src="/assets/ashley/ashley_3.png" alt="Office 1" className="ashley-life-img" />
              <img src="/assets/ashley/ashley_4.png" alt="Meeting 1" className="ashley-life-img" />
            </div>
            <div className="ashley-life-col ashley-life-center">
              <img src="/assets/ashley/ashley_2.png" alt="Main Office" className="ashley-life-img ashley-life-img-large" />
            </div>
            <div className="novac-life-col">
              <img src="/assets/ashley/ashley_5.png" alt="Office 2" className="ashley-life-img" />
              <img src="/assets/ashley/ashley_6.png" alt="Meeting 2" className="ashley-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}